import React from "react";
import * as R from "ramda";
import { Link } from "react-router-dom";
import { useRoom } from "../contexts/rooms";
import { useUser } from "../contexts/user";
import Spinner from "../components/Spinner";
import Navbar from "../components/Navbar";
import Page from "../components/Page";
import Header from "../components/Header";
import reloadPage from "../lib/reloadAndUpdate";
import navigationMessages from "../i18n/navigation";

import "./Room.css";

export function RoomView({
  match: {
    params: { roomId },
  },
}) {
  const { data, loading, error } = useRoom(roomId);
  const { user } = useUser();
  if (loading) {
    return <Spinner size="l" />;
  }
  if (error) {
    return <pre>{JSON.stringify(error, null, 2)}</pre>;
  }
  if (data) {
    const createdAt = new Date(data.createdAt);
    return (
      <Page>
        <Navbar
          items={[
            { to: "/rooms", text: navigationMessages.roomList },
            { to: "/logout", text: navigationMessages.logout },
            { to: "/", text: navigationMessages.reload, onClick: reloadPage },
          ]}
        />
        <Header size="h1" paddingX={10}>
          <div className="sub-title">Room name</div>
          {data.name}
        </Header>
        <Header size="h3" paddingX={10}>
          <div className="sub-title">Description</div>
          {data.description}
        </Header>
        <Header size="h3" paddingX={10}>
          <div className="sub-title">Result</div>
          <Link to={`/rooms/${roomId}/result`}>View 🖼</Link>
        </Header>
        <Header size="h3" paddingX={10}>
          <div className="sub-title">Width</div>
          {data.width} tiles
        </Header>
        <Header size="h3" paddingX={10}>
          <div className="sub-title">Height</div>
          {data.height} tiles
        </Header>
        <Header size="h3" paddingX={10}>
          <div className="sub-title">Created at</div>
          {createdAt.toLocaleString()}
        </Header>
        <Header size="h3" paddingX={10}>
          <div className="sub-title">Tiles</div>
        </Header>
        <div className="Room--tiles-container">
          <div
            className="Room--tiles"
            style={{
              width: data.width * 50,
              height: data.height * 50,
            }}
          >
            {data.tiles && renderTiles(data.tiles, roomId, user)}
          </div>
        </div>
      </Page>
    );
  }
  return (
    <Page>
      <Navbar
        items={[
          { to: "/rooms", text: "📚 Rooms" },
          { to: "/logout", text: "🚪 Logout" },
        ]}
      />
      <Header size="h3">Room {roomId} not found</Header>
    </Page>
  );
}

function renderTiles(tiles, roomId, user) {
  return R.pipe(
    R.toPairs,
    R.map(([tileId, tile]) => {
      const taken = !!tile.uid;
      const mine = user && tile.uid === user.uid;
      const to = `/rooms/${roomId}/tiles/${tileId}`;
      const className = "Room--tiles--tile";
      const style = {
        top: tile.y * 50,
        left: tile.x * 50,
        opacity: 1,
      };
      if (taken && !mine) {
        return (
          <div
            key={tileId}
            className={className}
            style={{
              ...style,
              opacity: 0.6,
            }}
          >
            <span role="img" aria-label="Draw">
              🚫
            </span>
          </div>
        );
      }
      if (mine) {
        return (
          <Link
            to={to}
            key={tileId}
            className={className}
            style={{
              ...style,
              opacity: 1,
            }}
          >
            <span role="img" aria-label="Draw">
              🎨
            </span>
          </Link>
        );
      }
      return (
        <Link
          to={to}
          key={tileId}
          className={className}
          style={{
            ...style,
            opacity: 1,
          }}
        />
      );
    })
  )(tiles);
}

export default RoomView;
